/*
 * Live Arrival Guarantee consent gate.
 *
 * Loaded from layout/theme.liquid so it runs on EVERY page load.
 *
 * It used to live in an inline <script> inside snippets/cart-summary.liquid.
 * That broke: with an empty cart the snippet is not rendered at all, so when the
 * shopper added their first item the theme injected the drawer markup as HTML and
 * an injected inline <script> never executes. No change listener was ever bound,
 * so ticking the box left checkout disabled until a full page reload.
 *
 * Everything below is bound at document level and re-applied on DOM changes, so it
 * survives drawer injection, section morphs and quantity re-renders.
 */
(function () {
  var ATTRIBUTE = 'Live Arrival Guarantee';
  var BOX = '.lag-consent__box';
  var BUTTON = '.cart__checkout-button';
  var EXPRESS = '.additional-checkout-buttons';
  var CLOSED = 'lag-gate-closed';

  // null = unknown, read the state the server rendered. Otherwise this is the truth,
  // so a re-render that arrives before the cart attribute lands cannot undo the tick.
  var accepted = null;
  var queued = false;

  function all(selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector));
  }

  function sync() {
    var boxes = all(BOX);

    // No consent box means no livestock in the cart. Leave checkout exactly as the
    // server rendered it and forget any earlier answer.
    if (!boxes.length) {
      accepted = null;
      return;
    }

    if (accepted === null) {
      accepted = boxes.some(function (box) {
        return box.checked;
      });
    }

    boxes.forEach(function (box) {
      if (box.checked !== accepted) box.checked = accepted;
    });

    // Delivery day picker (tcb-delivery-day.js): Friday delivery without protection also blocks checkout.
    var open = accepted && !(window.tcbDeliveryBlocked && window.tcbDeliveryBlocked());

    all(BUTTON).forEach(function (button) {
      if (button.disabled === open) button.disabled = !open;
    });

    all(EXPRESS).forEach(function (group) {
      if (group.classList.contains(CLOSED) === open) {
        group.classList.toggle(CLOSED, !open);
      }
    });
  }

  // Coalesce bursts of mutations into one pass.
  // Deliberately setTimeout and not requestAnimationFrame: rAF does not fire in a
  // background tab, so a shopper who switches away (or opens the guarantee link)
  // would come back to a gate that no longer re-syncs.
  function schedule() {
    if (queued) return;
    queued = true;
    window.setTimeout(function () {
      queued = false;
      sync();
    }, 16);
  }

  function record() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: (function () {
          var attributes = {};
          attributes[ATTRIBUTE] = accepted ? 'Accepted ' + new Date().toISOString() : '';
          return attributes;
        })()
      })
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.classList || !target.classList.contains('lag-consent__box')) return;

    accepted = target.checked;
    sync(); // unblock the shopper immediately, before the network round trip

    record()
      .catch(function () {})
      .then(function () {
        sync(); // the theme may re-render off the response
      });
  });

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled', 'checked', 'class']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
